import * as React from "react";

const ProductListingsNr: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill="currentColor"
                d="M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,1.5 C4.85786438,1.5 1.5,4.85786438 1.5,9 C1.5,13.1421356 4.85786438,16.5 9,16.5 C13.1421356,16.5 16.5,13.1421356 16.5,9 C16.5,4.85786438 13.1421356,1.5 9,1.5 Z M12.5,4.43933983 L13.5606602,5.5 L5.5,13.5606602 L4.43933983,12.5 L4.96966991,11.9696699 L11.9696699,4.96966991 L12.5,4.43933983 Z"
                transform="translate(1 1)"
            />
        </svg>
    );
};

export default React.memo(ProductListingsNr);
